<div class="row">
  <div class="col">
    <div class="page-nav-header no-pills">
      <div class="back-container">
        <button type="button" class="btn btn-transparent p-0" (click)="helperService.goBack()" aria-label="back">
          <fa-icon icon="arrow-left" class="circle-icon-btn" aria-hidden="true"></fa-icon>
          <span class="sr-only">back</span>
        </button>
        <fui-heading level="1" [text]="(cachedItem ? cachedItem.title : item?.title) || ('general.loading_dots' | translate)"></fui-heading>
        @if (cachedItem ? cachedItem.cloud_only : item?.cloud_only) {
          <span class="cloud_only_badge m-l-10">{{ "sphere.sphere_only" | translate | uppercase }}</span>
        }
        @if (item && !item.approved) {
          <span
            class="t-13"
            [class.unpublished]="myItem && item.category != 'soundset'"
            [class.not-approved]="!myItem || item.category == 'soundset'"
            placement="bottom"
            [ngbTooltip]="myItem ? 'This item is unpublished, and only viewable by you.' : 'A PreSonus administrator needs to approve this item. Contact support for more info.'"
          >
            {{ myItem && item.category != "soundset" ? ("sphere.unpublished" | translate | uppercase) : ("sphere.not_approved" | translate | uppercase) }}
          </span>
        }
      </div>
    </div>
  </div>
</div>

<myp-inline-loader [loading]="loading" height="400px" spinnerName="exchangeDetail"></myp-inline-loader>

@if (!loading) {
  <div class="row">
    <div class="col-md-9">
      <div class="exc-section">
        <h4 class="section-header m-b-10 m-t-30">
          {{ "profile.edit.description" | translate | uppercase }}
        </h4>
        {{ item.description ? item.description : ("sphere.no_description" | translate) }}
      </div>
      @if ((item.structure && item.structure.length) || (item.file_type_counts && item.file_type_counts.length)) {
        <div class="exc-section row">
          @if (item.structure && item.structure.length) {
            <div class="col-md-6">
              <h2 class="t-12 bold">{{ "sphere.soundset_structure" | translate | uppercase }}</h2>
              <br />
              <div [ngStyle]="{ height: showingWholeStructure ? 'auto' : '200px' }" style="overflow: hidden">
                @for (lvl1 of item.structure; track lvl1) {
                  <div>
                    <span class="lvl1">
                      <fa-icon [icon]="lvl1.type == 'folder' ? 'folder-open' : 'file'"></fa-icon>
                      {{ lvl1.name }}
                    </span>
                    @if (lvl1.type == "folder" && lvl1.contents && lvl1.contents.length) {
                      @for (lvl2 of lvl1.contents; track lvl2) {
                        <div>
                          <span class="lvl2">
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <fa-icon [icon]="lvl2.type == 'folder' ? 'folder-open' : 'file'"></fa-icon>
                            {{ lvl2.name }}
                          </span>
                          @if (lvl2.type == "folder" && lvl2.contents && lvl2.contents.length) {
                            @for (lvl3 of lvl2.contents; track lvl3) {
                              <div>
                                <span class="lvl3">
                                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                  <fa-icon [icon]="lvl3.type == 'folder' ? 'folder-open' : 'file'"></fa-icon>
                                  {{ lvl3.name }}
                                </span>
                                @if (lvl3.type == "folder" && lvl3.contents && lvl3.contents.length) {
                                  @for (lvl4 of lvl3.contents; track lvl4) {
                                    <div>
                                      <span class="lvl4">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        <fa-icon [icon]="lvl4.type == 'folder' ? 'folder-open' : 'file'"></fa-icon>
                                        {{ lvl4.name }}
                                      </span>
                                    </div>
                                  }
                                }
                              </div>
                            }
                          }
                        </div>
                      }
                    }
                  </div>
                }
              </div>
              <button class="small-btn" (click)="toggleWholeStructure()">
                {{ showingWholeStructure ? ("sphere.workspaces.show_less" | translate) : ("sphere.workspaces.show_more" | translate) }}
              </button>
            </div>
          }
          @if (item.file_type_counts && item.file_type_counts.length) {
            <div class="col-md-6">
              <h2 class="t-12 bold">{{ "sphere.files_included" | translate | uppercase }}</h2>
              <ul>
                @for (ftcItem of item.file_type_counts; track ftcItem) {
                  <li>{{ ftcItem.filetype + ": " + ftcItem.count }}</li>
                }
              </ul>
            </div>
          }
        </div>
      }
      @if (item.attributes && item.attributes.length) {
        <div class="exc-section">
          <h2 class="t-12 bold gothic">{{ "sphere.uses" | translate | uppercase }}</h2>
          <div class="grid-container pad-10">
            @for (attr of item.attributes; track attr) {
              <myp-product-tile [image]="attr.image" [title]="attr.name" [description]="'Vendor: ' + attr.vendor"></myp-product-tile>
            }
          </div>
        </div>
      }
      @if (audioPreviews.length) {
        <div class="exc-section">
          <h2 class="t-12 bold gothic">{{ "sphere.audio_previews" | translate | uppercase }}</h2>
          <br />
          @for (preview of audioPreviews; track preview) {
            <div class="preview">
              <h2 class="t-12 bold">{{ preview.fileName }}</h2>
              <br />
              <audio controls>
                <source [src]="preview.url" [type]="preview.mimeType" />
              </audio>
            </div>
          }
        </div>
      }
      @if (item.reviews && item.reviews.length) {
        <div class="exc-section">
          <h2 class="t-12 bold gothic">{{ "sphere.reviews" | translate | uppercase }}</h2>
          <div class="reviews">
            @for (review of item.reviews; track review) {
              <div class="review-block">
                <div>
                  @if (review.author && review.author.photoURL) {
                    <img
                      role="link"
                      tabindex="0"
                      (keyup.enter)="creatorClicked.next(review.author.id)"
                      (click)="creatorClicked.next(review.author.id)"
                      [src]="review.author.photoURL"
                      class="author-img"
                      alt="review author photo"
                    />
                  }
                  @if (review.author) {
                    <span role="link" tabindex="0" (keyup.enter)="creatorClicked.next(review.author.id)" (click)="creatorClicked.next(review.author.id)" class="author-name">
                      {{ review.author.firstName + " " + review.author.lastName }}
                    </span>
                  }
                  @if (!review.author) {
                    <span class="author-name">{{ "sphere.author_unknown" | translate }}</span>
                  }
                  <br />
                  <div class="comment">{{ review.comment }}</div>
                </div>
                <div>
                  <myp-stars [stars]="review.rating"></myp-stars>
                  <br />
                  <small class="edited-message text-center text-md-right d-block">{{ review.rating }}/5 stars</small>
                </div>
              </div>
            }
          </div>
        </div>
      }
      <div class="exc-section">
        <h4 class="section-header m-b-10 m-t-30">
          {{ "sphere.created_by" | translate | uppercase }}
        </h4>
        <div role="link" tabindex="0" class="created_by" tabindex="0" (keyup.enter)="creatorClicked.next(item.user.id)" (click)="creatorClicked.next(item.user.id)">
          <img
            [src]="item.user.photoURL ? item.user.photoURL : item.owner == 'PreSonus' ? './assets/images/presonus-profile-logo.png' : './assets/images/default_avatar.jpg'"
            style="width: 20%; max-width: 50px; border-radius: 200px; float: left; margin: 0px 10px 10px 0px"
            alt="creator user photo"
          />
          <strong>{{ item.user.firstName + " " + item.user.lastName }}</strong>
          <br />
          <small>{{ item.user.description ? item.user.description : ("sphere.no_description" | translate) }}</small>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <img [src]="'./assets/icons/exchange/' + item.extension + '.png'" style="width: 100%; max-width: 70px" [alt]="item.extension + ' logo'" />
      <br />
      <br />
      <myp-stars [stars]="item.rating ? item.rating.rating : 0"></myp-stars>
      <br />
      @if (item.rating) {
        <div>
          <small>{{ item.rating.rating }}/5 - {{ item.rating.total }} {{ "sphere.ratings" | translate }}</small>
        </div>
      }
      @if (user || cookieUser) {
        <div>
          @if (item.user?.id != loggedInUser.id) {
            <button class="small-btn" (click)="addReview()">{{ myReview ? ("sphere.edit_my_review" | translate) : ("sphere.add_my_review" | translate) }}</button>
          }
          <div class="m-t-20">
            <div>
              @if (item.downloads && item.downloads.length) {
                <button class="btn btn-primary" tabindex="0" (keyup.enter)="download()" (click)="download()">
                  <fa-icon [icon]="loadingSideBtn == 'download' ? 'spinner' : 'download'" [animation]="loadingSideBtn == 'download' ? 'spin' : undefined"></fa-icon>
                  &nbsp;
                  {{ "download.download" | translate }}
                </button>
              }
            </div>
            <div class="m-t-20">
              <button class="btn-secondary m-b-10 btn" tabindex="0" (keyup.enter)="favorite()" (click)="favorite()" [class.is_favorite]="item.favorite">
                <fa-icon [icon]="loadingSideBtn == 'favorite' ? 'spinner' : 'star'" [animation]="loadingSideBtn == 'favorite' ? 'spin' : undefined" [class.blue]="item.favorite"></fa-icon>
                &nbsp;
                {{ item.favorite ? ("sphere.unfavorite" | translate) : ("sphere.favorite" | translate) }}
              </button>
            </div>
            <div>
              @if (user && item.user?.id == user.id) {
                <button class="btn-secondary m-b-10 btn" (keyup.enter)="edit()" tabindex="0" (click)="edit()">
                  <fa-icon icon="pencil-alt"></fa-icon>
                  &nbsp;
                  {{ "sphere.edit" | translate }}
                </button>
              }
            </div>
            <div>
              @if (user && canBePublishedByUser) {
                <button class="btn-secondary m-b-10 btn" [class.approve]="!item.approved" [class.unapprove]="item.approved" tabindex="0" (keyup.enter)="toggleApprove()" (click)="toggleApprove()">
                  <fa-icon [icon]="loadingSideBtn == 'approving' ? 'spinner' : item.approved ? 'times' : 'check'" [animation]="loadingSideBtn == 'approving' ? 'spin' : undefined"></fa-icon>
                  &nbsp;
                  {{ item.approved ? ("sphere.unpublish" | translate) : ("sphere.publish" | translate) }}
                </button>
              }
            </div>
            <div>
              @if (user && user.is_admin && !item.approved) {
                <button class="btn btn-secondary m-b-10" (click)="toggleApprove()" tabindex="0" (keyup.enter)="toggleApprove()">
                  <fa-icon icon="check"></fa-icon>
                  &nbsp;
                  <span>{{ item.user?.id != loggedInUser.id ? ("sphere.approve" | translate) : ("sphere.publish" | translate) }}</span>
                </button>
              }
            </div>
            <div>
              @if (user && user.is_admin) {
                <button class="btn btn-secondary m-b-10" (click)="deny()" tabindex="0" (keyup.enter)="deny()">
                  <fa-icon icon="times"></fa-icon>
                  &nbsp;
                  {{ item.user?.id != loggedInUser.id ? ("sphere.deny_remove" | translate) : ("general.delete" | translate) }}
                </button>
              }
            </div>
            <div>
              @if (user && user.is_admin) {
                <button class="btn btn-secondary m-b-10" (click)="toggleSphere()" tabindex="0" (keyup.enter)="toggleSphere()">
                  <fa-icon [icon]="loadingSideBtn == 'sphereonly' ? 'spinner' : 'check'" [animation]="loadingSideBtn == 'sphereonly' ? 'spin' : undefined"></fa-icon>
                  &nbsp;
                  {{ item.cloud_only ? ("sphere.make_public" | translate) : ("sphere.make_sphere_only" | translate) }}
                </button>
              }
            </div>
          </div>
        </div>
      }
      <table class="metadata-table">
        <tr>
          <td class="left">{{ "sphere.category" | translate }}</td>
          <td class="right gothic">{{ item.category | uppercase }}</td>
        </tr>
        <tr>
          <td class="left">{{ "sphere.extension" | translate }}</td>
          <td class="right gothic">{{ item.extension | uppercase }}</td>
        </tr>
        <tr>
          <td class="left">{{ "sphere.created" | translate }}</td>
          <td class="right gothic">{{ item.created | date }}</td>
        </tr>
        <tr>
          <td class="left">{{ "sphere.downloaded" | translate }}</td>
          <td class="right gothic">{{ item.primaryDownloads }} times</td>
        </tr>
      </table>
    </div>
  </div>
}
